import { render } from "./ViewAttributes.vue?vue&type=template&id=1742631b"
import script from "./ViewAttributes.vue?vue&type=script&lang=js"
export * from "./ViewAttributes.vue?vue&type=script&lang=js"

import "./ViewAttributes.vue?vue&type=style&index=0&id=1742631b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__